import {http} from '@utils';
import {ActivityDetailVO, ReceiveRewardVO, SignInResultVO} from './types';

class CheckInService {
  /**
   * 获取签到活动详情
   *
   * 获取当前用户在周签到活动中的详细信息，包括：
   * - 当前日期和用户VIP等级
   * - 本周每日签到奖励配置列表
   * - 用户已签到天数统计
   * - 本周签到记录详情
   *
   * @returns {Promise<ActivityDetailVO>} 返回签到活动详情数据
   */
  getCheckDetail(): Promise<ActivityDetailVO> {
    return http.get('app/v1/activity/weeklySign/activityDetail');
  }

  // 用户签到
  // signRecord
  signIn(): Promise<SignInResultVO> {
    return http.post('app/v1/activity/weeklySign/signIn');
  }

  /**
   * 领取签到奖励
   *
   * 为用户领取当天的签到奖励，包括：
   * - 发放对应的奖励金额
   * - 更新签到记录状态
   * - 返回操作结果和奖励详情
   *
   * @returns {Promise<ReceiveRewardVO>} 返回领取奖励的结果，包含消息和奖励金额
   */
  receiveReward(): Promise<ReceiveRewardVO> {
    return http.post('app/v1/activity/weeklySign/receiveReward');
  }

  /**
   * 领取额外奖励
   *
   * 为用户领取周签到的额外奖励（通常是完成7天签到后的额外奖励），包括：
   * - 发放对应的额外奖励金额
   * - 更新签到记录状态
   * - 返回操作结果和奖励详情
   *
   * @returns {Promise<ReceiveRewardVO>} 返回领取奖励的结果，包含消息和奖励金额
   */
  receiveExtraReward(): Promise<ReceiveRewardVO> {
    return http.post('app/v1/activity/weeklySign/receiveExtraReward');
  }
}

export const rules = [
  'Target audience: All users can participate in this activity,Check-in takes a natural week as a cycle, and automatically resets after 7 days of check-in, repeating the cycle.',
  'The higher the VIP level, the more generous the rewards will be.',
  'Check-in method: After logging in to the platform for the first time every day, a check-in page will pop up to receive rewards after completing the tasks of the day. If you interrupt for any day, you will lose the rewards of the day.',
  'The higher the cumulative number of check-in days, the more generous the rewards.Accumulating 7 days per week can also earn additional prizes.',
  'The final interpretation right of the activity belongs to the platform. Participation is deemed as agreement to the relevant terms.',
];
export const checkInService = new CheckInService();
